const DEFAULT_ITEMS = [
  "PERFORMANCE TUNING",
  "ECU REFLASH",
  "PRECISION DIAGNOSTICS",
  "GERMAN VEHICLE SPECIALISTS",
  "FACTORY SCHEDULED MAINTENANCE",
];

export default function Marquee({ items }) {
  const list = items?.length ? items : DEFAULT_ITEMS;
  const row = [...list, ...list];
  return (
    <div className="border-y border-[#263342] bg-[#0D1117] py-4 overflow-hidden" data-testid="editorial-marquee">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="font-mono text-sm uppercase tracking-[0.3em] text-slate-500 px-2">
                {item} <span className="text-crimson px-4">///</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
